import store from '@/store';

export const HasAcceptedTermsGuard = (to, from, next) => {
  const user = store.getters.currentUser;
  if (user.terms_accepted) {
    return next();
  }

  return next({name: 'terms'});
};